// All bilingual copy. Keys are stable; values are { ru, uz }.

export const T = {
  nav: {
    home: { ru: "Главная", uz: "Bosh sahifa" },
    how: { ru: "Как работает", uz: "Qanday ishlaydi" },
    models: { ru: "Модели", uz: "Modellar" },
    forWhom: { ru: "Для кого", uz: "Kimlar uchun" },
    delivery: { ru: "Доставка", uz: "Yetkazib berish" },
    faq: { ru: "FAQ", uz: "FAQ" },
  },
  cta: {
    callNow: { ru: "Позвонить сейчас", uz: "Hozir qo'ng'iroq qilish" },
    callShort: { ru: "Позвонить", uz: "Qo'ng'iroq" },
    callManager: { ru: "Позвонить менеджеру", uz: "Menejerga qo'ng'iroq qilish" },
    pickModel: { ru: "Подобрать модель", uz: "Model tanlash" },
    writeWhatsApp: { ru: "Написать в WhatsApp", uz: "WhatsApp'ga yozish" },
    writeTelegram: { ru: "Написать в Telegram", uz: "Telegram'ga yozish" },
    callAvailability: { ru: "Позвонить и узнать наличие", uz: "Qo'ng'iroq qilib mavjudligini bilish" },
    callDelivery: { ru: "Позвонить и уточнить доставку", uz: "Qo'ng'iroq qilib yetkazib berishni aniqlash" },
    callConfirm: { ru: "Позвонить и подтвердить модель", uz: "Qo'ng'iroq qilib modelni tasdiqlash" },
    startQuiz: { ru: "Пройти квиз", uz: "Kvizdan o'tish" },
    callConsult: { ru: "Позвонить консультанту", uz: "Maslahatchiga qo'ng'iroq qiling" },
  },
  hero: {
    chip: { ru: "Air Cooler · Не кондиционер", uz: "Air Cooler · Konditsioner emas" },
    h1: { ru: "Свежий поток воздуха без монтажа", uz: "O'rnatishsiz toza havo oqimi" },
    sub: {
      ru: "Мобильные водяные охладители Air Cooler для дома и бизнеса. Работают через воду, легко перемещаются и помогают сделать воздух комфортнее в жару.",
      uz: "Uy va biznes uchun mobil suvli Air Cooler. Suv orqali ishlaydi, oson ko'chiriladi va yozgi issiqda havoni qulayroq qiladi.",
    },
    priceBadge: { ru: "от 170$", uz: "170$ dan" },
    priceMicro: { ru: "Точную модель подберём по помещению", uz: "Mos modelni joyingizga qarab tanlaymiz" },
    urgency: {
      ru: "Сезон жары уже начался — уточните наличие сегодня",
      uz: "Issiq mavsum boshlandi — bugun mavjudligini aniqlang",
    },
    microUnderCTA: {
      ru: "Звонок — самый быстрый способ узнать наличие и подобрать модель.",
      uz: "Qo'ng'iroq — mavjudlikni bilish va model tanlashning eng tez usuli.",
    },
    trust: {
      ru: ["Склад в Ташкенте", "Доставка по Узбекистану", "Без сложного монтажа", "Консультация по подбору"],
      uz: ["Toshkentda ombor", "O'zbekiston bo'ylab yetkazib berish", "Murakkab montajsiz", "Model tanlash bo'yicha maslahat"],
    },
  },
  urgencyStrip: {
    text: {
      ru: "Нужен охладитель срочно? Позвоните — подскажем модель и наличие за 1 минуту.",
      uz: "Sovutgich tez kerakmi? Qo'ng'iroq qiling — model va mavjudlikni 1 daqiqada aytamiz.",
    },
  },
  problem: {
    h2: { ru: "Жара мешает жить, работать и продавать?", uz: "Issiq yashash, ishlash va sotishga xalaqit beryaptimi?" },
    list: {
      ru: [
        "Дома душно даже вечером",
        "Детям и пожилым тяжело переносить жару",
        "В магазине покупатели быстрее уходят",
        "В кафе гости меньше сидят на летней зоне",
        "В офисе сотрудники быстрее устают",
        "Кондиционер дорогой или его нельзя установить",
        "Вентилятор гоняет тёплый воздух",
      ],
      uz: [
        "Uyda kechqurun ham dim havo",
        "Bolalar va kattalar issiqni qiyin ko'taradi",
        "Do'konda mijozlar tezroq chiqib ketadi",
        "Kafeda mehmonlar uzoq o'tirmaydi",
        "Ofisda xodimlar tez charchaydi",
        "Konditsioner qimmat yoki o'rnatish imkoni yo'q",
        "Ventilyator issiq havoni aylantiradi",
      ],
    },
  },
  how: {
    h2: { ru: "Как работает Air Cooler", uz: "Air Cooler qanday ishlaydi" },
    text: {
      ru: "Air Cooler — это мобильный водяной охладитель воздуха. Воздух проходит через увлажнённые элементы, вода испаряется, и поток становится свежее и комфортнее. Это не кондиционер и не сплит-система, поэтому он не охлаждает помещение так же глубоко, но помогает легче переносить жару без сложного монтажа.",
      uz: "Air Cooler — bu mobil suvli havo sovutgich. Havo namlangan elementlardan o'tadi, suv bug'lanadi va havo oqimi yanada salqinroq va qulayroq bo'ladi. Bu konditsioner yoki split tizim emas, shuning uchun xonani u kabi chuqur sovutmaydi, ammo murakkab montajsiz issiqni yengilroq o'tkazishga yordam beradi.",
    },
    bullets: {
      ru: ["работает через воду", "легко перемещается", "не требует сложного монтажа", "подходит для дома и бизнеса", "помогает создать свежий поток воздуха"],
      uz: ["suv orqali ishlaydi", "oson ko'chiriladi", "murakkab montaj talab qilmaydi", "uy va biznes uchun mos", "toza havo oqimini yaratishga yordam beradi"],
    },
  },
  segments: {
    h2: { ru: "Куда нужен охладитель?", uz: "Sovutgich qayerga kerak?" },
    items: [
      {
        key: "home",
        title: { ru: "Дом", uz: "Uy" },
        desc: { ru: "Для квартиры, спальни, детской или частного дома.", uz: "Kvartira, yotoqxona, bolalar xonasi yoki hovli uyi uchun." },
        rec: "Z-1050 / Z-1250",
        image: "/images/aircooler/4.png",
      },
      {
        key: "store",
        title: { ru: "Магазин", uz: "Do'kon" },
        desc: { ru: "Чтобы покупателям и продавцам было комфортнее в жару.", uz: "Issiqda mijozlar va sotuvchilar uchun qulayroq muhit." },
        rec: "Z-1250 / Z-1380",
        image: "/images/aircooler/6.png",
      },
      {
        key: "cafe",
        title: { ru: "Кафе", uz: "Kafe" },
        desc: { ru: "Для летних зон, террас и помещений, где гости проводят время.", uz: "Yozgi hududlar, terrasalar va mehmonlar o'tiradigan joylar uchun." },
        rec: "Z-1380 / Z-1530",
        image: "/images/aircooler/7.png",
      },
      {
        key: "office",
        title: { ru: "Офис", uz: "Ofis" },
        desc: { ru: "Для дополнительного свежего потока в open-space или кабинете.", uz: "Open-space yoki kabinetda qo'shimcha toza havo oqimi uchun." },
        rec: "Z-1250 / Z-1380",
        image: "/images/aircooler/3.png",
      },
      {
        key: "warehouse",
        title: { ru: "Склад", uz: "Ombor" },
        desc: { ru: "Для больших помещений, складов и производственных зон.", uz: "Katta joylar, omborlar va ishlab chiqarish hududlari uchun." },
        rec: "Z-1530 / Z-900",
        image: "/images/aircooler/8.png",
      },
    ],
  },
  models: {
    h2: { ru: "Модели и цены", uz: "Modellar va narxlar" },
    sub: {
      ru: "Выберите модель по ориентиру помещения. Точный подбор сделаем по звонку после уточнения площади и условий.",
      uz: "Joyiingizga qarab model tanlang. Aniq tanlovni qo'ng'iroq orqali maydon va sharoitni aniqlagandan keyin qilamiz.",
    },
    badge: { ru: "Точные параметры уточняются", uz: "Aniq parametrlar aniqlashtiriladi" },
    notSure: {
      ru: "Не уверены, какая модель нужна? Позвоните — подберём за 1 минуту.",
      uz: "Qaysi model kerakligini bilmaysizmi? Qo'ng'iroq qiling — 1 daqiqada tanlaymiz.",
    },
  },
  comparison: {
    h2: { ru: "Честное сравнение: Air Cooler, кондиционер и вентилятор", uz: "Halol taqqoslash: Air Cooler, konditsioner va ventilyator" },
    headers: {
      ru: ["Параметр", "Air Cooler", "Кондиционер", "Вентилятор"],
      uz: ["Parametr", "Air Cooler", "Konditsioner", "Ventilyator"],
    },
    rows: {
      ru: [
        ["Монтаж", "Без монтажа", "Сложная установка", "Не нужен"],
        ["Мобильность", "Да, на колёсах", "Стационарный", "Да"],
        ["Стоимость покупки", "Доступнее", "Высокая", "Низкая"],
        ["Стоимость установки", "—", "Существенная", "—"],
        ["Охлаждение", "Свежий поток", "Глубокое охлаждение", "Гоняет тёплый воздух"],
        ["Полуоткрытые зоны", "Подходит", "Не эффективен", "Подходит"],
        ["Кому подходит", "Дом, бизнес, летние зоны", "Закрытые комнаты", "Точечный обдув"],
      ],
      uz: [
        ["O'rnatish", "Montajsiz", "Murakkab o'rnatish", "Kerak emas"],
        ["Mobillik", "Ha, g'ildirakda", "Statsionar", "Ha"],
        ["Sotib olish narxi", "Arzonroq", "Yuqori", "Past"],
        ["O'rnatish narxi", "—", "Sezilarli", "—"],
        ["Sovutish", "Toza oqim", "Chuqur sovutish", "Issiq havoni aylantiradi"],
        ["Yarim ochiq joy", "Mos", "Samarasiz", "Mos"],
        ["Kimga mos", "Uy, biznes, yozgi joylar", "Yopiq xonalar", "Nuqtali shamollatish"],
      ],
    },
    cta: { ru: "Позвонить и понять, подходит ли Air Cooler вам", uz: "Air Cooler sizga mos kelishini bilish uchun qo'ng'iroq qiling" },
  },
  consult: {
    h2: {
      ru: "Не знаете, какую модель выбрать? Позвоните — подберём по помещению",
      uz: "Qaysi modelni tanlashni bilmaysizmi? Qo'ng'iroq qiling — joyingizga qarab tanlaymiz",
    },
    sub: {
      ru: "Скажите менеджеру, куда нужен охладитель, примерную площадь и город. Мы быстро подскажем подходящую модель, наличие и условия доставки.",
      uz: "Menejerga sovutgich qayerga kerakligini, taxminiy maydonni va shaharingizni ayting. Mos model, mavjudlik va yetkazib berish shartlarini tez aytamiz.",
    },
    micro: { ru: "Обычно консультация занимает 1–2 минуты", uz: "Odatda maslahat 1–2 daqiqa davom etadi" },
  },
  trust: {
    h2: { ru: "Склад, доставка и консультация в Узбекистане", uz: "O'zbekistonda ombor, yetkazib berish va maslahat" },
    items: {
      ru: ["Склад в Ташкенте", "Доставка по Ташкенту и регионам", "Консультация по подбору модели", "Оплата удобным способом — уточнить", "Гарантия — уточнить у поставщика"],
      uz: ["Toshkentda ombor", "Toshkent va hududlarga yetkazib berish", "Model tanlash bo'yicha maslahat", "Qulay to'lov usuli — aniqlashtirish kerak", "Kafolat — yetkazib beruvchidan aniqlashtirish kerak"],
    },
  },
  quiz: {
    h2: { ru: "Подберём модель за 1 минуту", uz: "1 daqiqada mos modelni tanlaymiz" },
    steps: {
      where: { ru: "Куда нужен охладитель?", uz: "Sovutgich qayerga kerak?" },
      size: { ru: "Размер помещения", uz: "Joy hajmi" },
      city: { ru: "Ваш город", uz: "Shaharingiz" },
      contact: { ru: "Контакт для подтверждения", uz: "Tasdiqlash uchun kontakt" },
      result: { ru: "Ваша модель", uz: "Sizning modelingiz" },
    },
    sizes: {
      ru: [{ k: "small", v: "Маленькое" }, { k: "medium", v: "Среднее" }, { k: "large", v: "Большое" }, { k: "xl", v: "Очень большое" }],
      uz: [{ k: "small", v: "Kichik" }, { k: "medium", v: "O'rtacha" }, { k: "large", v: "Katta" }, { k: "xl", v: "Juda katta" }],
    },
    cities: ["Ташкент / Toshkent", "Самарканд / Samarqand", "Бухара / Buxoro", "Фергана / Farg'ona", "Андижан / Andijon", "Наманган / Namangan", "Другой / Boshqa"],
    namePh: { ru: "Ваше имя", uz: "Ismingiz" },
    phonePh: { ru: "Телефон, +998…", uz: "Telefon, +998…" },
    resultLine: {
      ru: "Предварительно вам подойдёт модель",
      uz: "Dastlab sizga mos keladi",
    },
    resultSub: {
      ru: "Точный подбор сделает менеджер после уточнения помещения.",
      uz: "Aniq tanlovni menejer joyingizni aniqlagandan keyin qiladi.",
    },
    next: { ru: "Далее", uz: "Davom etish" },
    back: { ru: "Назад", uz: "Orqaga" },
    submit: { ru: "Получить результат", uz: "Natijani olish" },
    submitted: { ru: "Заявка принята. Менеджер свяжется в ближайшее время.", uz: "So'rov qabul qilindi. Menejer tez orada bog'lanadi." },
  },
  faq: {
    h2: { ru: "Частые вопросы", uz: "Tez-tez beriladigan savollar" },
    items: {
      ru: [
        ["Это кондиционер?", "Нет, Air Cooler — это не кондиционер. Это мобильный водяной охладитель воздуха. Он работает через воду и создаёт свежий поток воздуха, но не охлаждает помещение так глубоко, как сплит-система."],
        ["Реально охлаждает?", "Он создаёт более свежий и влажный поток воздуха, что помогает легче переносить жару. Это не полноценная замена сплит-системе."],
        ["Чем отличается от вентилятора?", "Вентилятор просто гоняет воздух. Air Cooler пропускает воздух через увлажнённые элементы, и поток становится свежее."],
        ["Как выбрать модель?", "Ориентируйтесь на тип и размер помещения. Точный подбор сделает менеджер по звонку."],
        ["Подойдёт для квартиры?", "Да — для гостиной, спальни, детской. Идеально для аренды, где нельзя ставить кондиционер."],
        ["Подойдёт для магазина или кафе?", "Да — особенно для торговых залов и летних террас."],
        ["Можно ли использовать на складе?", "Да — для этого есть более мощные модели Z-1530 и Z-900."],
        ["Что нужно заливать?", "Воду. Точные требования к воде — уточняйте у менеджера."],
        ["Как часто доливать воду?", "Зависит от модели и режима. Подскажет менеджер."],
        ["Есть ли гарантия?", "Гарантия — нужно уточнить у поставщика по телефону."],
        ["Сколько стоит доставка?", "Доставка по Ташкенту и регионам — уточняется у менеджера."],
        ["Можно ли заказать по телефону?", "Да. Нажмите кнопку «Позвонить» — менеджер уточнит помещение, город и подберёт подходящую модель."],
      ],
      uz: [
        ["Bu konditsionermi?", "Yo'q, Air Cooler konditsioner emas. Bu mobil suvli havo sovutgich. U suv orqali ishlaydi va toza havo oqimini yaratadi, lekin split tizim kabi xonani chuqur sovutmaydi."],
        ["Haqiqatan sovutadimi?", "U yanada toza va namroq havo oqimini yaratadi, bu issiqni yengilroq o'tkazishga yordam beradi. Bu split tizimga to'liq almashtiruvchi emas."],
        ["Ventilyatordan farqi?", "Ventilyator faqat havoni aylantiradi. Air Cooler havoni namlangan elementlar orqali o'tkazadi va oqim salqinroq bo'ladi."],
        ["Modelni qanday tanlash?", "Joy turi va o'lchamiga qarab. Aniq tanlovni menejer qo'ng'iroq orqali qiladi."],
        ["Kvartiraga mos keladimi?", "Ha — mehmonxona, yotoqxona, bolalar xonasi uchun. Konditsioner o'rnatish imkonsiz bo'lgan ijara uchun ideal."],
        ["Do'kon yoki kafega mosmi?", "Ha — ayniqsa savdo zallari va yozgi terrasalar uchun."],
        ["Omborda ishlatish mumkinmi?", "Ha — buning uchun Z-1530 va Z-900 kuchli modellari bor."],
        ["Nima quyish kerak?", "Suv. Suvga aniq talablar — menejerdan aniqlang."],
        ["Suvni qanchalik tez-tez quyish kerak?", "Modelga va rejimga bog'liq. Menejer aytadi."],
        ["Kafolat bormi?", "Kafolat — yetkazib beruvchidan telefon orqali aniqlashtirish kerak."],
        ["Yetkazib berish narxi?", "Toshkent va hududlarga yetkazib berish — menejerdan aniqlang."],
        ["Telefon orqali buyurtma berish mumkinmi?", "Ha. 'Qo'ng'iroq qilish' tugmasini bosing — menejer joyingizni, shahringizni aniqlaydi va mos modelni tanlaydi."],
      ],
    },
  },
  finalCta: {
    h2: { ru: "Жара уже началась — подберите модель сегодня", uz: "Issiq kunlar boshlandi — bugun mos modelni tanlang" },
    sub: { ru: "Позвоните менеджеру: уточним помещение, подберём модель и проверим наличие.", uz: "Menejerga qo'ng'iroq qiling: joyingizni aniqlaymiz, model tanlaymiz va mavjudligini tekshiramiz." },
    urgency: { ru: "Сезонный спрос растёт — лучше уточнить наличие сегодня.", uz: "Mavsumiy talab oshmoqda — mavjudlikni bugun aniqlagan yaxshi." },
  },
  footer: {
    rights: { ru: "© Havo Comfort · Все права защищены", uz: "© Havo Comfort · Barcha huquqlar himoyalangan" },
    disclaimer: {
      ru: "Air Cooler — мобильный испарительный охладитель воздуха. Не является кондиционером и не заменяет сплит-систему. Технические характеристики уточняются у поставщика.",
      uz: "Air Cooler — mobil bug'lanadigan havo sovutgich. Konditsioner emas va split tizimni almashtirmaydi. Texnik xususiyatlar yetkazib beruvchidan aniqlashtiriladi.",
    },
  },
  whatsappMsg: {
    ru: "Здравствуйте! Хочу подобрать Air Cooler. Помещение: ___. Город: ___. Подскажите подходящую модель.",
    uz: "Salom! Air Cooler tanlashga yordam bering. Joy: ___. Shahar: ___. Mos modelni tavsiya qiling.",
  },
};

export const t = (path, lang) => {
  const parts = path.split(".");
  let cur = T;
  for (const p of parts) cur = cur?.[p];
  if (cur && typeof cur === "object" && (cur.ru || cur.uz)) return cur[lang] || cur.ru;
  return cur;
};
